// extracted by mini-css-extract-plugin
module.exports = {"svg":"download_svg__rzKPh","logo":"download_logo__gE2T6","arrow":"download_arrow__3fIHH"};